import { buildAdminV2RevenueAffiliateEndpoints } from "./adminV2RevenueAffiliateEndpoints";
import { buildAdminV2RevenueCatalogEndpoints } from "./adminV2RevenueCatalogEndpoints";
import { buildAdminV2RevenueReadEndpoints } from "./adminV2RevenueReadEndpoints";
import type { ApiEndpointBuilder } from "../baseApi";

/**
 * Revenue/billing Admin V2 endpoint definitions extracted from `baseApi.ts`.
 *
 * @remarks
 * Keeps the single RTK Query API instance (`apiSlice`) intact while reducing
 * monolith endpoint churn in one file.
 */
export const buildAdminV2RevenueEndpoints = (builder: ApiEndpointBuilder) => ({
    ...buildAdminV2RevenueReadEndpoints(builder),
    ...buildAdminV2RevenueCatalogEndpoints(builder),
    ...buildAdminV2RevenueAffiliateEndpoints(builder),
});
